import {CheckCircleFillIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {mergeabilityStatus, Status} from '@github-ui/mergebox/helpers/mergeability-status'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useGoToMergeBox} from '../../mergebox/use-go-to-mergebox'
import {useMergeabilityData} from './use-mergeability-data'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'

export function shouldShowReadyToMerge(data: ReturnType<typeof useMergeabilityData>) {
  return (
    !!data &&
    mergeabilityStatus({
      pullRequest: data.mergeBoxPullRequest,
      mergeRequirements: data.mergeRequirements,
      statusChecksData: data.statusChecksData,
    }) === Status.Mergeable
  )
}

// Renders for the author/assignees when the pull request is mergeable ("Ready to merge"),
// offering a shortcut that scrolls to the merge box so they can complete the merge.
export function ReadyToMerge({variant}: {variant?: 'default' | 'embedded'}) {
  const data = useMergeabilityData()
  const goToMergeBox = useGoToMergeBox()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  if (!shouldShowReadyToMerge(data)) return null

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={CheckCircleFillIcon} variant="success" />}
      title="Ready to merge"
      itemName="ready-to-merge"
      variant={variant}
      actionSlot={
        <Button
          size="small"
          onClick={event => {
            sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
              item_name: 'ready-to-merge',
              action_name: 'go_to_merge_box',
            })
            goToMergeBox(event.currentTarget)
          }}
        >
          Go to merge box
        </Button>
      }
    />
  )
}
